import { storageCategories } from '../../PSPPage/utils/getPSPLinks';

export const linkToOtherPSPsBlock = {
	title: 'Link to other PSPs',
	background: 'lighterBlue',
	modules: [
		{
			type: 'links',
			props: {
				heading: {
					headingName: 'More ways to store',
				},
				type: 'unitCards',
				id: 'storage size unit cards',
				linksList: storageCategories.sgp,
			},
		},
	],
};
